import ACTIONS from 'constants/actionTypes';
import { createAction } from 'helpers/redux';
import { filtersKeysType } from 'types/Filters';

export const changeQuickFilter = (
  name: string,
  key: filtersKeysType,
  value: any
) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.CHANGE_QUICK_FILTER,
        payload: {
          name,
          key,
          value,
        },
      })
    );
  };
};

export const resetConcreteQuickFilters = ({ name }: { name: string }) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.RESET_CONCRETE_QUICK_FILTERS,
        payload: { name },
      })
    );
  };
};

export const resetConcreteQuickFiltersProps = ({
  name,
  keys,
}: {
  name: string;
  keys: Array<string>;
}) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.RESET_CONCRETE_QUICK_FILTERS_PROPS,
        payload: { name, keys },
      })
    );
  };
};

export const resetQuickFilters = () => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.RESET_QUICK_FILTERS,
      })
    );
  };
};

export const initQuickFilters = (payload) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.INIT_QUICK_FILTERS,
        payload,
      })
    );
  };
};
